// useCheckMobileScreen.js
import { useEffect, useState } from "react";
import debounce from "lodash.debounce";

const useCheckMobileScreen = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia("(max-width: 767px)").matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleChange = debounce(() => {
      setIsMobile(mediaQuery.matches);
    }, 100); // adjust delay as needed

    // Add the listener
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
      handleChange.cancel(); // Cancel debounce on cleanup
    };
  }, []);

  return isMobile;
};

export default useCheckMobileScreen;
